import { useTranslation } from 'react-i18next';

export default function Footer() {
  const currentYear = new Date().getFullYear();
  const { t } = useTranslation();

  return (
    <footer className="bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-700 mt-auto">
      <div className="max-w-7xl mx-auto py-4 px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row justify-between items-center gap-2">
          <p className="text-sm text-gray-500 dark:text-gray-400">
            © {currentYear}{' '}
            <a
              href="https://devfactory.ai"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-gray-700 dark:hover:text-gray-300 transition-colors underline"
            >
              Devfactory.ai
            </a>
            . Tous droits réservés.
          </p>
          <div className="flex items-center gap-4 text-sm text-gray-500 dark:text-gray-400">
            <a href="/documentation" className="hover:text-gray-700 dark:hover:text-gray-300 transition-colors">
              {t('nav.documentation')}
            </a>
            <span className="text-gray-300 dark:text-gray-600">|</span>
            <a href="/activity-logs" className="hover:text-gray-700 dark:hover:text-gray-300 transition-colors">
              {t('nav.activityLogs')}
            </a>
            <span className="text-gray-300 dark:text-gray-600">|</span>
            <span>Version 1.1</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
